export const YEARS = Array.from({ length: 27 }, (_, i) => String(2026 - i));

export const MAKES_MODELS: Record<string, string[]> = {
  Acura: ["MDX", "RDX"],
  Audi: ["Q5", "Q7", "Q8", "SQ7", "SQ8", "e-tron", "Q8 e-tron"],
  BMW: ["X5", "X6", "X7"],
  Buick: ["Enclave", "Envision", "Rainier", "Rendezvous"],
  Cadillac: ["Escalade", "Escalade ESV", "Escalade IQ", "XT5", "XT6"],
  Chevrolet: [
    "Silverado 1500", "Silverado 2500HD", "Silverado 3500HD",
    "Colorado", "Tahoe", "Suburban", "Traverse",
    "Avalanche", "TrailBlazer", "Equinox", "Blazer",
  ],
  Chrysler: ["Aspen", "Pacifica", "Town & Country", "300"],
  Dodge: [
    "Durango", "Dakota", "Ram 1500", "Ram 2500", "Ram 3500",
    "Nitro", "Journey", "Grand Caravan", "Ramcharger",
  ],
  Ford: [
    "F-150", "F-250", "F-350", "F-450",
    "Ranger", "Maverick", "Expedition", "Explorer",
    "Bronco", "Excursion", "E-350", "E-450",
    "Flex", "Edge", "Transit",
  ],
  GMC: [
    "Sierra 1500", "Sierra 2500HD", "Sierra 3500HD",
    "Canyon", "Yukon", "Yukon XL", "Acadia",
    "Hummer EV", "Hummer EV SUV", "Envoy",
  ],
  Honda: ["Ridgeline", "Pilot", "Passport", "Odyssey"],
  Hyundai: ["Santa Cruz", "Palisade", "Tucson", "Santa Fe"],
  Infiniti: ["QX50", "QX55", "QX60", "QX70", "QX80", "FX35", "FX45"],
  Jeep: [
    "Gladiator", "Grand Cherokee", "Wrangler",
    "Grand Cherokee L", "Commander",
  ],
  KIA: ["Telluride", "Sorento", "Sportage", "Carnival", "Sedona", "EV9"],
  "Land Rover": [
    "Range Rover", "Range Rover Sport", "Discovery", "Discovery Sport",
    "Defender", "LR3", "LR4",
  ],
  Lexus: [
    "GX 460", "GX 470", "GX 550", "LX 470", "LX 570", "LX 600",
    "RX 350", "RX 450h", "TX 500h", "TX 550h",
  ],
  Lincoln: ["Navigator", "Aviator", "Nautilus"],
  Mazda: ["CX-9", "CX-90", "CX-50"],
  "Mercedes-Benz": [
    "GLS-Class", "GLE-Class", "G-Class", "GL-Class", "ML-Class",
    "Sprinter", "Metris",
  ],
  Mitsubishi: [
    "Outlander", "Outlander Sport", "Endeavor",
    "Montero", "Montero Sport", "Raider",
  ],
  Nissan: [
    "Titan", "Titan XD", "Frontier",
    "Pathfinder", "Armada", "Murano", "Xterra",
    "NV1500", "NV2500", "NV3500",
  ],
  Porsche: ["Cayenne", "Macan"],
  RAM: ["1500", "2500", "3500"],
  Subaru: ["Outback", "Ascent"],
  Suzuki: ["Grand Vitara", "XL7", "Equator"],
  Toyota: [
    "Tundra", "Tacoma", "4Runner", "Sequoia",
    "Land Cruiser", "Highlander", "Grand Highlander",
  ],
  Volkswagen: ["Atlas"],
  Volvo: ["XC60", "XC90", "XC40"],
};

export const CAB_TYPES = ["Regular Cab", "Extended/Super Cab", "Crew Cab", "Mega Cab"];
export const AXLE_TYPES = ["2WD", "4WD / 4x4", "AWD"];
